import { http } from '../../utils/http'

export const BPBASE = window.$envUtils('VUE_APP_BP_SERVICE')
export const CRMBASE = window.$envUtils('VUE_APP_CRM_SERVICE')
// 用户数据excel导入
export const customImport = (data) => {
  return new Promise((resolve, reject) => {
    http.post(`${CRMBASE}/customer/custom-import`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 客户列表导入模板
export const getcustomerImportExcel = (params) => {
  return new Promise((resolve, reject) => {
    http.get(`${CRMBASE}/customer/mould-excel`, { params, responseType: 'blob' }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 下载用户错误Excel模板
export const customerErrorExcel = (params) => {
  return new Promise((resolve, reject) => {
    http.get(`${CRMBASE}/customer/error-excel`, { params, responseType: 'blob' }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 客户信息分页查询
export const getClientInfo = (data) => {
  return new Promise((resolve, reject) => {
    http.post(`${CRMBASE}/customer/findByPage`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 查询客户信息详情[id]
export const getCustomerDetail = (id) => {
  return new Promise((resolve, reject) => {
    http.get(`${CRMBASE}/customer/findDetail/${id}`).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 查询符合条件的所有客户数据(用于导出客户)
export const getAllClientInfo = (data) => {
  return new Promise((resolve, reject) => {
    http.post(`${CRMBASE}/customer/findByList`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 根据id批量删除客户，ids为待删除id数组的Json字符串
export const deleteCustomer = (data) => {
  return new Promise((resolve, reject) => {
    http.delete(`${CRMBASE}/customer/deleteBatch`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}
// 查询开启的字段
export const getOpenCols = (data) => {
  return new Promise((resolve, reject) => {
    http.get(`${CRMBASE}/customerCol/findOpenCols/${data}`).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 保存自定义字段
export const saveCustomerCol = (data) => {
  return new Promise((resolve, reject) => {
    http.post(`${CRMBASE}/customerCol/`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 更新自定义字段
export const updateCustomerCol = (data) => {
  return new Promise((resolve, reject) => {
    http.put(`${CRMBASE}/customerCol/`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 更新自定义字段
export const updateCustomerColStatus = (data) => {
  return new Promise((resolve, reject) => {
    http.put(`${CRMBASE}/customerCol/updateStatus/`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 删除自定义字段
export const deleteCustomerCol = (data) => {
  return new Promise((resolve, reject) => {
    http.delete(`${CRMBASE}/customerCol/`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 自定义字段分页
export const getCustomerColByPage = (params) => {
  return new Promise((resolve, reject) => {
    http.get(`${CRMBASE}/customerCol/findByPage`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}
// 根据筛选条件查询自定义字段集合
export const getCustomerField = (params) => {
  return new Promise((resolve, reject) => {
    http.get(`${BPBASE}/system/custom_field/get`, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 配置相关接口
// 查询客户保存规则
export const getCustomerSaveRules = (module) => {
  return new Promise((resolve, reject) => {
    http.get(`${CRMBASE}/configs/listConfigFields/${module}`).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 更新配置
export const updateCustomerSaveRules = (data) => {
  return new Promise((resolve, reject) => {
    http.put(`${CRMBASE}/configs/`, { data }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}
